import { cn } from '@dfh-corp-sites/ui/utils'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useEffect, useMemo } from 'react'

import { SanityEduModule } from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'

export const EduModule: React.FC<SanityEduModule> = ({ title, image, content }) => {
  const sideImageComponent = useMemo(() => {
    return getGatsbyImageDataForAsset(image, {})
  }, [image])

  useEffect(() => {
    setAnalyticsEvent({
      _key: 'eduModule',
      event: 'select_content',
      content_type: 'eduModule',
      item_id: 'eduModule',
      title: title || '',
      module_name: 'eduModule',
      label_text: title ?? '',
    })
  }, [title])

  return (
    <div
      className={cn([
        'w-full bg-white',
        'my-12',
        'px-6 md:px-12 xl:px-[60px]',
        'max-w-[1280px] mx-auto',
      ])}
    >
      <div className="h-[1px] w-full bg-brand-navy mb-10" />

      <div className={cn(['flex flex-col gap-[80px]', 'md:flex-row'])}>
        <div className={cn(['w-full', 'md:w-[50%]'])}>
          <h2
            className={cn([
              'text-brand-navy-2 text-[32px] font-medium mt-6 leading-[110%]',
              'md:text-[40px]',
            ])}
          >
            {title}
          </h2>

          {content?.split('\n').map((paragraph: string, index: number) => (
            <p key={index} className="mt-5 text-base text-brand-navy leading-[175%] font-normal">
              {paragraph}
            </p>
          ))}
        </div>

        <div className={cn(['w-full h-auto', 'md:w-[50%]'])}>
          {sideImageComponent && (
            <GatsbyImage
              className="w-full h-full object-cover"
              image={sideImageComponent}
              alt=""
              loading="eager"
            />
          )}
        </div>
      </div>
    </div>
  )
}
